import React from 'react'

const Report = () => {
  return (
    <div>
      Staff Reports
    </div>
  )
}

export default Report;
